<empathy-conditions-saved [conditions]="conditions()" [previousQuestions]="previousQuestions()" (removeCondition)="remove.emit($event)"></empathy-conditions-saved>

@if (isEditing()) {
  <empathy-conditional-logic-form
    [isFirstCondition]="conditions().length === 0"
    [previousQuestions]="previousQuestions()"
    (save)="save.emit($event)"
    (cancel)="cancel.emit()"
  ></empathy-conditional-logic-form>
} @else {
  <button mat-stroked-button color="primary" class="add-more-button" (click)="addMore.emit()">
    {{ conditions().length === 0 ? 'Add a condition' : 'Add more conditions' }}
  </button>
}
